module.exports = {
      id: "minority_logo-usage",
      viewBox: "0 0 49 16",
      url: __webpack_public_path__ + "images/js_src_vue/page_listary_landing/sprite.d9b7df9a.svg#minority_logo-usage",
      toString: function () {
        return this.url;
      }
    }